import React from 'react';
import { Bar } from "react-chartjs-2";
import "chart.js/auto";

const ENTRANCE_COLOR = '#f59e0b'; // amber
const EXIT_COLOR = '#3b82f6';     // blue

export default function OverviewBarChart({ buckets, theme, height = 320 }) {
  const txt = theme === 'light' ? '#333' : '#e5e5e5';

  if (!buckets || !buckets.length) {
    return (
      <div style={{ height, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#888' }}>
        No data for the selected range
      </div>
    );
  }

  const data = {
    labels: buckets.map(b => b.label),
    datasets: [
      { label: 'Entrances', data: buckets.map(b => b.count),    backgroundColor: ENTRANCE_COLOR, borderRadius: 4, maxBarThickness: 48 },
      { label: 'Exits',     data: buckets.map(b => b.countOut), backgroundColor: EXIT_COLOR,     borderRadius: 4, maxBarThickness: 48 },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        grid: { display: false },
        ticks: { color: txt, autoSkip: true, maxRotation: 0, minRotation: 0 },
        title: { display: true, text: 'Period', color: txt },
      },
      y: {
        beginAtZero: true,
        grid: { color: theme === 'light' ? 'rgba(0,0,0,0.06)' : 'rgba(255,255,255,0.08)' },
        ticks: { color: txt, precision: 0 },
        title: { display: true, text: 'People', color: txt },
      },
    },
    plugins: {
      legend: { labels: { color: txt, usePointStyle: true, pointStyle: 'rectRounded' } },
      tooltip: {
        callbacks: { label: (c) => ` ${c.dataset.label}: ${Number(c.raw).toLocaleString()} people` },
      },
    },
  };

  return <div style={{ height }}><Bar data={data} options={options} /></div>;
}